import { useBundleInspectorStore } from '../../store/bundleInspectorStore';
import BundleInspectorPanelComponent from './BundleInspectorPanelComponent';

// The bundle inspector's bundle panel, in the top left corner while a bundle is selected.
// Keyed by the bundles, so selecting another one opens it on its first tab.
const BundleInspectorPanelOverlay = () => {
    const { pinnedBundles, pinnedElements, onUnpin, onDetach } = useBundleInspectorStore();
    if (!pinnedBundles || !onUnpin) return null;

    return (
        <div className="bundleInspectorPanelOverlay">
            <BundleInspectorPanelComponent key={pinnedBundles.map(b => b.id).join(",")}
                                            bundles={pinnedBundles} elements={pinnedElements} onClose={onUnpin}
                                            onDetachElements={onDetach ?? undefined} />
        </div>
    );
};

export default BundleInspectorPanelOverlay;
